// Honor of Kings hero data — official Tencent CDN images
// Source: https://pvp.qq.com/web201605/js/herolist.json
// Image pattern: https://game.gtimg.cn/images/yxzj/img201606/heroimg/{ename}/{ename}.jpg

const HOK_HEROES = [
  { ename: 105, slug: "lianpo", name: "Lian Po", cname: "廉颇" },
  { ename: 106, slug: "xiaoqiao", name: "Xiao Qiao", cname: "小乔" },
  { ename: 107, slug: "zhaoyun", name: "Zhao Yun", cname: "赵云" },
  { ename: 108, slug: "mozi", name: "Mozi", cname: "墨子" },
  { ename: 109, slug: "daji", name: "Daji", cname: "妲己" },
  { ename: 110, slug: "yingzheng", name: "Ying Zheng", cname: "嬴政" },
  { ename: 111, slug: "sunshangxiang", name: "Sun Shangxiang", cname: "孙尚香" },
  { ename: 112, slug: "lubanno7", name: "Luban No.7", cname: "鲁班七号" },
  { ename: 113, slug: "zhuangzhou", name: "Zhuang Zhou", cname: "庄周" },
  { ename: 114, slug: "liushan", name: "Liu Shan", cname: "刘禅" },
  { ename: 115, slug: "gaojianli", name: "Gao Jianli", cname: "高渐离" },
  { ename: 116, slug: "ake", name: "Ake", cname: "阿轲" },
  { ename: 117, slug: "zhongwuyan", name: "Zhong Wuyan", cname: "钟无艳" },
  { ename: 118, slug: "sunbin", name: "Sun Bin", cname: "孙膑" },
  { ename: 119, slug: "bianque", name: "Bian Que", cname: "扁鹊" },
  { ename: 120, slug: "baiqi", name: "Bai Qi", cname: "白起" },
  { ename: 121, slug: "miyue", name: "Mi Yue", cname: "芈月" },
  { ename: 123, slug: "lubu", name: "Lu Bu", cname: "吕布" },
  { ename: 124, slug: "zhouyu", name: "Zhou Yu", cname: "周瑜" },
  { ename: 125, slug: "yuange", name: "Yuan Ge", cname: "元歌" },
  { ename: 126, slug: "xiahoudun", name: "Xiahou Dun", cname: "夏侯惇" },
  { ename: 127, slug: "zhenji", name: "Zhen Ji", cname: "甄姬" },
  { ename: 128, slug: "caocao", name: "Cao Cao", cname: "曹操" },
  { ename: 129, slug: "dianwei", name: "Dian Wei", cname: "典韦" },
  { ename: 130, slug: "musashi", name: "Musashi", cname: "宫本武藏" },
  { ename: 131, slug: "libai", name: "Li Bai", cname: "李白" },
  { ename: 132, slug: "marcopolo", name: "Marco Polo", cname: "马可波罗" },
  { ename: 133, slug: "direnjie", name: "Di Renjie", cname: "狄仁杰" },
  { ename: 134, slug: "dharma", name: "Dharma", cname: "达摩" },
  { ename: 135, slug: "xiangyu", name: "Xiang Yu", cname: "项羽" },
  { ename: 136, slug: "wuzetian", name: "Wu Zetian", cname: "武则天" },
  { ename: 137, slug: "simayi", name: "Sima Yi", cname: "司马懿" },
  { ename: 139, slug: "laofuzi", name: "Lao Fuzi", cname: "老夫子" },
  { ename: 140, slug: "guanyu", name: "Guan Yu", cname: "关羽" },
  { ename: 141, slug: "diaochan", name: "Diaochan", cname: "貂蝉" },
  { ename: 142, slug: "angela", name: "Angela", cname: "安琪拉" },
  { ename: 144, slug: "chengyaojin", name: "Cheng Yaojin", cname: "程咬金" },
  { ename: 146, slug: "luna", name: "Luna", cname: "露娜" },
  { ename: 148, slug: "jiangziya", name: "Jiang Ziya", cname: "姜子牙" },
  { ename: 149, slug: "liubang", name: "Liu Bang", cname: "刘邦" },
  { ename: 150, slug: "hanxin", name: "Han Xin", cname: "韩信" },
  { ename: 151, slug: "sunquan", name: "Sun Quan", cname: "孙权" },
  { ename: 152, slug: "wangzhaojun", name: "Wang Zhaojun", cname: "王昭君" },
  { ename: 153, slug: "lanling", name: "Lanling Wang", cname: "兰陵王" },
  { ename: 154, slug: "mulan", name: "Mulan", cname: "花木兰" },
  { ename: 155, slug: "erin", name: "Erin", cname: "艾琳" },
  { ename: 156, slug: "zhangliang", name: "Zhang Liang", cname: "张良" },
  { ename: 157, slug: "maishiranui", name: "Mai Shiranui", cname: "不知火舞" },
  { ename: 159, slug: "doria", name: "Doria", cname: "朵莉亚" },
  { ename: 162, slug: "nakoruru", name: "Nakoruru", cname: "娜可露露" },
  { ename: 163, slug: "ukyo", name: "Ukyo Tachibana", cname: "橘右京" },
  { ename: 166, slug: "arthur", name: "Arthur", cname: "亚瑟" },
  { ename: 167, slug: "sunwukong", name: "Sun Wukong", cname: "孙悟空" },
  { ename: 168, slug: "niumo", name: "Niumo", cname: "牛魔" },
  { ename: 169, slug: "houyi", name: "Hou Yi", cname: "后羿" },
  { ename: 170, slug: "liubei", name: "Liu Bei", cname: "刘备" },
  { ename: 171, slug: "zhangfei", name: "Zhang Fei", cname: "张飞" },
  { ename: 172, slug: "chichi", name: "Chi Chi", cname: "蚩奼" },
  { ename: 173, slug: "liyuanfang", name: "Li Yuanfang", cname: "李元芳" },
  { ename: 174, slug: "yuji", name: "Yu Ji", cname: "虞姬" },
  { ename: 175, slug: "zhongkui", name: "Zhong Kui", cname: "钟馗" },
  { ename: 176, slug: "yangyuhuan", name: "Yang Yuhuan", cname: "杨玉环" },
  { ename: 177, slug: "cang", name: "Cang", cname: "苍" },
  { ename: 178, slug: "yangjian", name: "Yang Jian", cname: "杨戬" },
  { ename: 179, slug: "nuwa", name: "Nuwa", cname: "女娲" },
  { ename: 180, slug: "nezha", name: "Nezha", cname: "哪吒" },
  { ename: 182, slug: "ganjiangmoye", name: "Ganjiang Moye", cname: "干将莫邪" },
  { ename: 183, slug: "athena", name: "Athena", cname: "雅典娜" },
  { ename: 184, slug: "caiwenji", name: "Cai Wenji", cname: "蔡文姬" },
  { ename: 186, slug: "taiyizhenren", name: "Taiyi Zhenren", cname: "太乙真人" },
  { ename: 187, slug: "donghuangtaiyi", name: "Donghuang Taiyi", cname: "东皇太一" },
  { ename: 188, slug: "dayu", name: "Da Yu", cname: "大禹" },
  { ename: 189, slug: "guiguzi", name: "Guiguzi", cname: "鬼谷子" },
  { ename: 190, slug: "zhugeliang", name: "Zhuge Liang", cname: "诸葛亮" },
  { ename: 191, slug: "daqiao", name: "Da Qiao", cname: "大乔" },
  { ename: 192, slug: "huangzhong", name: "Huang Zhong", cname: "黄忠" },
  { ename: 193, slug: "garo", name: "Garo", cname: "铠" },
  { ename: 194, slug: "sulie", name: "Su Lie", cname: "苏烈" },
  { ename: 195, slug: "bailixuance", name: "Baili Xuance", cname: "百里玄策" },
  { ename: 196, slug: "bailishouyue", name: "Baili Shouyue", cname: "百里守约" },
  { ename: 197, slug: "yixing", name: "Yixing", cname: "弈星" },
  { ename: 198, slug: "mengqi", name: "Mengqi", cname: "梦奇" },
  { ename: 199, slug: "gongsunli", name: "Gongsun Li", cname: "公孙离" },
  { ename: 501, slug: "mingshiyin", name: "Ming Shiyin", cname: "明世隐" },
  { ename: 502, slug: "peiqinhu", name: "Pei Qinhu", cname: "裴擒虎" },
  { ename: 503, slug: "kuangtie", name: "Kuang Tie", cname: "狂铁" },
  { ename: 504, slug: "milady", name: "Milady", cname: "米莱狄" },
  { ename: 505, slug: "yao", name: "Yao", cname: "瑶" },
  { ename: 506, slug: "yunzhongjun", name: "Yunzhong Jun", cname: "云中君" },
  { ename: 507, slug: "lixin", name: "Li Xin", cname: "李信" },
  { ename: 508, slug: "jialuo", name: "Jialuo", cname: "伽罗" },
  { ename: 509, slug: "dunshan", name: "Dun Shan", cname: "盾山" },
  { ename: 510, slug: "sunce", name: "Sun Ce", cname: "孙策" },
  { ename: 511, slug: "zhubajie", name: "Zhu Bajie", cname: "猪八戒" },
  { ename: 513, slug: "shangguanwaner", name: "Shangguan Wan'er", cname: "上官婉儿" },
  { ename: 514, slug: "yalian", name: "Yalian", cname: "亚连" },
  { ename: 515, slug: "change", name: "Chang'e", cname: "嫦娥" },
  { ename: 517, slug: "dasiming", name: "Da Siming", cname: "大司命" },
  { ename: 518, slug: "machao", name: "Ma Chao", cname: "马超" },
  { ename: 519, slug: "aoyin", name: "Ao Yin", cname: "敖隐" },
  { ename: 521, slug: "haiyue", name: "Hai Yue", cname: "海月" },
  { ename: 522, slug: "yaoshining", name: "Yao (Shining)", cname: "曜" },
  { ename: 523, slug: "xishi", name: "Xishi", cname: "西施" },
  { ename: 524, slug: "mengya", name: "Meng Ya", cname: "蒙犽" },
  { ename: 525, slug: "lubanmaster", name: "Luban Master", cname: "鲁班大师" },
  { ename: 527, slug: "mengtian", name: "Meng Tian", cname: "蒙恬" },
  { ename: 528, slug: "lan", name: "Lan", cname: "澜" },
  { ename: 529, slug: "pangu", name: "Pangu", cname: "盘古" },
  { ename: 531, slug: "jing", name: "Jing", cname: "镜" },
  { ename: 533, slug: "aguduo", name: "Aguduo", cname: "阿古朵" },
  { ename: 534, slug: "sangqi", name: "Sang Qi", cname: "桑启" },
  { ename: 536, slug: "charlotte", name: "Charlotte", cname: "夏洛特" },
  { ename: 537, slug: "sikongzhen", name: "Sikong Zhen", cname: "司空震" },
  { ename: 538, slug: "yunying", name: "Yun Ying", cname: "云缨" },
  { ename: 540, slug: "jinchan", name: "Jin Chan", cname: "金蝉" },
  { ename: 542, slug: "fei", name: "Fei", cname: "暃" },
  { ename: 544, slug: "zhaohuaizhen", name: "Zhao Huaizhen", cname: "赵怀真" },
  { ename: 545, slug: "laixio", name: "Lai Xio", cname: "莱西奥" },
  { ename: 548, slug: "goya", name: "Goya", cname: "戈娅" },
  { ename: 550, slug: "kongkonger", name: "Kong Kong'er", cname: "空空儿" },
  { ename: 558, slug: "ying", name: "Ying", cname: "影" },
  { ename: 563, slug: "haino", name: "Haino", cname: "海诺" },
  { ename: 564, slug: "jixiaoman", name: "Ji Xiaoman", cname: "姬小满" },
  { ename: 577, slug: "shaosiyuan", name: "Shao Siyuan", cname: "少司缘" },
  { ename: 581, slug: "yuanliutank", name: "Yuanliu (Tank)", cname: "元流之子(坦克)" },
  { ename: 582, slug: "yuanliumage", name: "Yuanliu (Mage)", cname: "元流之子(法师)" },
  { ename: 583, slug: "yuanliuassassin", name: "Yuanliu (Assassin)", cname: "元流之子(刺客)" },
  { ename: 584, slug: "yuanliumarksman", name: "Yuanliu (Marksman)", cname: "元流之子(射手)" },
  { ename: 585, slug: "yuanliusupport", name: "Yuanliu (Support)", cname: "元流之子(辅助)" },
];

export const HeroData = HOK_HEROES.reduce((acc, h) => {
  acc[h.slug] = {
    id: String(h.ename),
    name: h.name,
    cname: h.cname,
    imageUrl: `https://game.gtimg.cn/images/yxzj/img201606/heroimg/${h.ename}/${h.ename}.jpg`,
  };
  return acc;
}, {});

export default {
  HeroData,
  getHeroById: (id) => HeroData[id.toLowerCase()] || null,
  getHeroByName: (name) => {
    const lower = name.toLowerCase();
    const key = Object.keys(HeroData).find(k =>
      HeroData[k].name.toLowerCase() === lower ||
      (HeroData[k].cname && HeroData[k].cname === name)
    );
    return key ? HeroData[key] : null;
  },
  getAllHeroNames: () => {
    const uniqueNames = new Set();
    Object.values(HeroData).forEach(c => uniqueNames.add(c.name));
    return Array.from(uniqueNames).sort();
  }
};
